<div *ngIf="loadingState$ | async" class="overlay">
  <mat-progress-spinner
    class="spinner"
    [color]="color"
    [mode]="mode"
    [value]="value"
    [diameter]="diameter"
  >
  </mat-progress-spinner>
</div>
